module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="authorization-page">\n\n</div>\n';

}
return __p
}